import createIcon from '../../createIcon';

/**
 * @component @name AddBusiness
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTUuNUgxN1YxMi41SDE4VjEwLjVMMTcgNS41SDJMMSAxMC41VjEyLjVIMlYxOC41SDExVjEyLjVIMTVWMTUuNVpNOSAxNi41SDRWMTIuNUg5VjE2LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcgMi41SDJWNC41SDE3VjIuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAxNi41VjEzLjVIMThWMTYuNUgxNVYxOC41SDE4VjIxLjVIMjBWMTguNUgyM1YxNi41SDIwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddBusiness = createIcon('AddBusiness', [
  [
    'path',
    {
      d: 'M15 15.5H17V12.5H18V10.5L17 5.5H2L1 10.5V12.5H2V18.5H11V12.5H15V15.5ZM9 16.5H4V12.5H9V16.5Z',
      key: 'lk2y5w',
    },
  ],
  ['path', { d: 'M17 2.5H2V4.5H17V2.5Z', key: 'c3qidq' }],
  ['path', { d: 'M20 16.5V13.5H18V16.5H15V18.5H18V21.5H20V18.5H23V16.5H20Z', key: '11oeca' }],
]);

export default AddBusiness;
